import { isEqual } from 'lodash';

import { hasEmail, isValidEmail } from '../../../utils/inputValidation';
import { blankStudent } from '../constants/inviteStudentsDefaults';
import { Student } from '../types/inviteStudentsTypes';
import { UserRoles } from '../../../components/roster/types';

export type EmailErrorKeys = '' | 'required-email' | 'invalid-email' | 'duplicate-email';
export type NameErrorKeys = '' | 'required-first-name' | 'required-last-name' | 'invalid-name';
export type RoleErrorKeys = '' | 'invalid-role';

export const findDuplicateEmailIndexes = (students: Student[]) => {
    const seenEmails: string[] = [];
    const indexesOfDuplicates: number[] = [];

    students.forEach((student, index) => {
        if (seenEmails.includes(student.email)) indexesOfDuplicates.push(index);
        else seenEmails.push(student.email);
    });

    return indexesOfDuplicates;
};

const isValidName = (name: unknown): boolean => typeof name === 'string';
const hasName = (firstName: string): boolean => firstName.trim().length > 0;

export const isValidRole = (role: any): boolean =>
    [UserRoles.Student, UserRoles.Assistant, UserRoles.Teacher].includes(role.trim().toLowerCase());

export const emailValidation = (email: string): EmailErrorKeys => {
    if (!hasEmail(email)) return 'required-email';
    if (!isValidEmail(email)) return 'invalid-email';

    return '';
};

export const firstNameValidation = (firstName: string): NameErrorKeys => {
    if (!isValidName(firstName)) return 'invalid-name';
    if (!hasName(firstName)) return 'required-first-name';

    return '';
};

export const lastNameValidation = (lastName: string): NameErrorKeys => {
    if (!isValidName(lastName)) return 'invalid-name';
    if (!hasName(lastName)) return 'required-last-name';

    return '';
};

export const roleValidation = (role: string | undefined): RoleErrorKeys => {
    if (!role) return '';

    if (!isValidRole(role)) return 'invalid-role';

    return '';
};

export const validateStudentInvitations = (students: Student[]) => {
    const newErrorIndexes: number[] = [];
    const indexesOfDuplicateEmails = findDuplicateEmailIndexes(students);

    students.forEach((student, index) => {
        if (isEqual(student, blankStudent)) {
            // ignore blank rows
            return;
        }

        if (
            !!firstNameValidation(student.firstName) ||
            !!lastNameValidation(student.lastName) ||
            !!emailValidation(student.email) ||
            !!roleValidation(student.role) ||
            indexesOfDuplicateEmails.includes(index)
        ) {
            newErrorIndexes.push(index);
        }
    });

    return newErrorIndexes;
};
